import { render } from "./SpecialtySection.vue?vue&type=template&id=3f360c92&scoped=true"
import script from "./SpecialtySection.vue?vue&type=script&lang=js"
export * from "./SpecialtySection.vue?vue&type=script&lang=js"

import "./SpecialtySection.vue?vue&type=style&index=0&id=3f360c92&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f360c92"]])

export default __exports__